export default "__VITE_ASSET__HuqqqRWB__"